var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxDropDownButton',{staticClass:"gc-dropdown-icon-button",attrs:{"items":_vm.getItems,"keyExpr":_vm.keyExpr,"displayExpr":_vm.displayExpr,"drop-down-options":_vm.getDropDownOptions,"styling-mode":"text","show-arrow-icon":false,"onItemClick":_vm.onItemClick,"disabled":_vm.disabled,"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }